import { Page } from 'react-pdf';
import { useElementSize } from '@custom-react-hooks/use-element-size';
import { CircularProgress } from '@mui/material';

import { StyledContainer, StyledDocument, StyledLoadingContainer } from './styled';

export const ARROW_BUTTON_SIZE = 36;
export const ARROW_BUTTON_GAP_SIZE = 5;
const MAX_PDF_WIDTH = 320;

type PreviewSmallPdfViewerProps = {
  link?: string;
};
export default function PreviewSmallPdfViewer({ link }: PreviewSmallPdfViewerProps) {
  const [setRef, size] = useElementSize();

  const calculatedPdfWidth = size.width - (ARROW_BUTTON_SIZE + ARROW_BUTTON_GAP_SIZE * 2) * 2;
  const pdfWidth = Math.min(MAX_PDF_WIDTH, calculatedPdfWidth);

  const pfdHeight = pdfWidth * 1.8;

  return (
    <StyledContainer ref={setRef}>
      <StyledDocument
        file={link}
        sx={{ height: pfdHeight }}
        loading={
          <StyledLoadingContainer sx={{ height: pfdHeight, width: pdfWidth }}>
            <CircularProgress />
          </StyledLoadingContainer>
        }
      >
        <Page pageIndex={0} width={pdfWidth} />
      </StyledDocument>
    </StyledContainer>
  );
}
